import moduleConfig from './module-config';
import netsAgentQueueDetails from './nets-agent-queue-details';

export default angular
  .module('app.agent-queue-details', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsAgentQueueDetails', netsAgentQueueDetails);
